export const getSecurityAccess = (projectID, projectUserGroups, restrictedGroupTypeIDs) => {
	// console.log('projectID: ', projectID);
	// console.log('projectUserGroups: ', projectUserGroups);
	// console.log('restrictedGroupTypeIDs: ', restrictedGroupTypeIDs);

	let restricted = false;

	if (projectID !== undefined && restrictedGroupTypeIDs !== undefined) {
		// Loop through each project assigned to the user
		for (let i = 0; i < projectUserGroups.length; i++) {
			if (projectUserGroups[i].projectID === projectID) {

				// Loop through each restricted value
				for (let x = 0; x < restrictedGroupTypeIDs.length; x++) {
					if (projectUserGroups[i].groupTypeID === restrictedGroupTypeIDs[x]) {
						restricted = true;
						break;
					}
				}

				if (restricted) {
					break;
				}
			}
		}
	} else {
		restricted = true;
	}

	return restricted;
}